import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" id=\"checkmark\"><path d=\"M11.084,17.811L6.158,12.884L7.925,11.116L10.999,14.19L20.117,4.159L21.966,5.841L11.084,17.811Z\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(-7.57 -3.288) scale(1.3917)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol